import React from "react";
import { downloadLoader } from "../../types/types";
import "./downloadLoader.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
const DownloadLoader = (props: downloadLoader) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const closeModal = () => {
    props.setOpenReportModal(false);
  };
  return (
    <div className="report-reportDownloading card">
      <div className="report-crossButton" onClick={closeModal}>
        X
      </div>
      <div className="report-message">{translate(TranslationEnum.common_portal,props.message)}</div>
      <div className="report-loding-progress">
        <div className="report-percent-progress">
          <div className="report-porges"></div>
        </div>
      </div>
    </div>
  );
};

export default DownloadLoader;
